export default {
  en: {
    title: 'Agents',
    subtitle: 'List of agents or executives who serve clients.',
    columns: {
      name: 'Full Name',
      departments: 'Departments',
      email: 'Email',
      status: 'Connection Status',
      activity: 'Last call',
      statusActivity: 'Last connection status',
    },
    form: {
      firstname: {
        error: 'Please fill the first name of agent.',
        help: 'This is the first name of agent.',
      },
      lastname: {
        error: 'Please fill the last name of agent.',
        help: 'This is the last name of agent.',
      },
      email: {
        error: 'Please fill the email of agent.',
        help: 'Enter the email or username that your agent will access, remember that a username (not email) will not be able to recover the password by mail link.',
      },
      password: {
        error: 'The password must be at least 6 characters.',
        help: 'If you don\'t set a password, we send a link to email for change the password. ¡Remember use a valid email!',
        create: 'Create a password',
      },
      departments: {
        error: '',
        help: 'Select the departments in which the agents will attend.',
      },
      privilege: {
        error: 'Select a privilege for the agent.',
        help: 'This define the permissions of agent. Can be default or customized.',
      },
      passwordConfirm: {
        error: 'The passwords does not match.',
      },
      availability: {
        hint: 'Agent days and hours availability',
      }
    },
    notification: {
      success: {
        patch: 'The agent {email} was edited successful.',
        post: 'The agent {email} was created successful | The {email} was created successful, we send email for set activate account.',
      },
      fail: {
        conflict: 'The email or username is already used, please choose another.',
        username: 'If you don\'t set a password provide a valid email.\n\n On the contrary case please provide a password and username.',
        password: 'Password not strong enough. Please provide a stronger password',
      },
      permissions: 'Your don\'t have permissions to {action} agents. If you believe this is wrong try again or contact us.',
    },
    subscriptions: 'You have {available} users available of {total} for create.',
    noSubscriptions: 'Sorry but you reach the maximum {total} of users. Contact to us to get more.',
    disconnectionLog: 'Disconnection log',
    sessionId: 'Session id',
    filters: {
      text: 'Search by names, email, etc.',
      label: 'Filters',
    },
    statuses: {
      available: 'Available',
      occupied: 'ACD',
      meeting: 'Meeting',
      inCall: 'In call',
      busy: 'Occupied',
      break: 'Break',
      bath: 'Bath',
      meal: 'Meal',
      gathering: 'Team meeting',
      training: 'Training',
      disconnected: 'Disconnected',
      releasing: 'Available',
      occupying: 'ACD',
    },
    disconnectionReason: {
      transportClose: 'network problem or browser shutdown',
      clientNamespaceDisconnect: 'manual disconnection',
      pingTimeout: 'high network latency',
      serverNamespaceDisconnect: 'user disconnected by server',
    },
    metrics: {
      dailyHours: {
        label: 'Hours of daily connection',
        hint: 'Hours per day agent is connection in a year view',
      },
      occupancyLevel: {
        label: 'Daily occupancy level (%)',
        hint: 'Occupancy percentage between hours on call and hours connected',
      },
      connectionLogs: {
        label: 'Logs connections',
        hint: 'History of connections',
      }
    }
  },
  es: {
    title: 'Agentes',
    subtitle: 'Lista de agentes o ejecutivos que atienden a sus clientes.',
    columns: {
      name: 'Nombre',
      departments: 'Departamentos',
      email: 'Correo electrónico',
      status: 'Estado de conexión',
      activity: 'Última llamada',
      statusActivity: 'Último estado de conexión',
    },
    form: {
      firstname: {
        error: 'Por favor llene el nombre del agente.',
        help: 'Este es el primer nombre del agente.',
      },
      lastname: {
        error: 'Por favor llene el apellido del agente.',
        help: 'Este es el apellido del agente.',
      },
      email: {
        error: 'Por favor complete el correo electrónico del agente.',
        help: 'Ingrese el correo electrónico o nombre de usuario con el que accederá su agente, recuerde que un nombre de usuario (no email) no podrá recuperar la contraseña por correo electrónico.',
      },
      password: {
        error: 'La contraseña debe ser de al menos 6 caracteres.',
        help: 'Si no establece una contraseña, le enviaremos un enlace por correo electrónico para cambiar la contraseña. ¡Recuerda usar un correo electrónico válido!',
        create: 'Crear una contraseña',
      },
      departments: {
        error: '',
        help: 'Seleccione los departamentos a los que pertenecerá el agente.',
      },
      privilege: {
        error: 'Seleccione un privilegio para el agente.',
        help: 'Esto define los permisos del agente. Puede ser predeterminado o personalizado.',
      },
      passwordConfirm: {
        error: 'Las contraseñas no coinciden.',
      },
      availability: {
        hint: 'Días y horas disponibles del agente',
      }
    },
    notification: {
      success: {
        patch: 'El agente {email} fue editado exitosamente.',
        post: 'El agente {email} fue creado exitosamente. | El agente {email} fue creado exitosamente, le hemos enviado un correo para la activación.',
      },
      fail: {
        conflict: 'El correo electrónico o nombre de usuario ya está en uso, elija otro.',
        username: 'Si no establece una contraseña, proporcione un correo electrónico válido.\n\n Por el contrario, proporcione una contraseña y nombre de usuario.',
        password: 'Contraseña no lo suficientemente fuerte. Proporcione una contraseña más fuerte',
      },
      permissions: 'No tienes permisos para {action} agentes. Si crees que esto está mal, intente nuevamente o contáctenos.',
    },
    subscriptions: 'Tienes {available} usuarios disponibles de un total de {total}, para crear.',
    noSubscriptions: 'Ups! Haz alcanzado el límite de {total} usuarios disponibles. Contáctanos para adquirir más.',
    disconnectionLog: 'Registro de desconexión',
    sessionId: 'ID de sesión',
    filters: {
      text: 'Buscar por nombres, correo, etc.',
      label: 'Filtros',
    },
    statuses: {
      available: 'Disponible',
      occupied: 'ACD',
      meeting: 'Reunión',
      inCall: 'En llamada',
      busy: 'Ocupado',
      break: 'Descanso',
      bath: 'Baño',
      meal: 'Comida',
      gathering: 'Reunión de equipo',
      training: 'Capacitación',
      disconnected: 'Desconectado',
      releasing: 'Disponible',
      occupying: 'ACD',
    },
    disconnectionReason: {
      transportClose: 'problema de red o cierre del navegador',
      clientNamespaceDisconnect: 'desconexión manual',
      pingTimeout: 'alta latencia en red',
      serverNamespaceDisconnect: 'usuario desconectado por servidor',
    },
    metrics: {
      dailyHours: {
        label: 'Horas de conexión diaria',
        hint: 'Horas por día de conexión del agente en una vista anual',
      },
      occupancyLevel: {
        label: 'Nivel de ocupación diaria (%)',
        hint: 'Porcentaje de ocupación entre horas en llamada vs horas conectado',
      },
      connectionLogs: {
        label: 'Registro de conexiones',
        hint: 'Historial de conexiones',
      }
    }
  },
  fr: {
    title: 'Agents',
    subtitle: 'Liste des agents ou des cadres qui servent les clients.',
    columns: {
      name: 'Nom Complet',
      departments: 'Départements',
      email: 'Email',
      status: 'Statut de Connexion',
      activity: 'Dernier appel',
      statusActivity: 'Dernier statut de connexion',
    },
    form: {
      firstname: {
        error: 'Veuillez remplir le prénom de l\'agent.',
        help: 'C\'est le prénom de l\'agent.',
      },
      lastname: {
        error: 'Veuillez remplir le nom de famille de l\'agent.',
        help: 'C\'est le nom de famille de l\'agent.',
      },
      email: {
        error: 'Veuillez remplir l\'email de l\'agent.',
        help: 'Entrez l\'email ou le nom d\'utilisateur que votre agent utilisera pour accéder, sachez qu\'un nom d\'utilisateur (et non un email) ne pourra pas récupérer le mot de passe par lien mail.',
      },
      password: {
        error: 'Le mot de passe doit comporter au moins 6 caractères.',
        help: 'Si vous ne définissez pas de mot de passe, nous enverrons un lien par email pour changer le mot de passe. N\'oubliez pas d\'utiliser un email valide !',
        create: 'Créer un mot de passe',
      },
      departments: {
        error: '',
        help: 'Sélectionnez les départements dans lesquels les agents seront affectés.',
      },
      privilege: {
        error: 'Sélectionnez un privilège pour l\'agent.',
        help: 'Cela définit les permissions de l\'agent. Peut être par défaut ou personnalisé.',
      },
      passwordConfirm: {
        error: 'Les mots de passe ne correspondent pas.',
      },
      availability: {
        hint: 'Disponibilité des jours et heures de l\'agent',
      }
    },
    notification: {
      success: {
        patch: 'L\'agent {email} a été modifié avec succès.',
        post: 'L\'agent {email} a été créé avec succès | Le {email} a été créé avec succès, nous avons envoyé un email pour activer le compte.',
      },
      fail: {
        conflict: 'L\'email ou le nom d\'utilisateur est déjà utilisé, veuillez en choisir un autre.',
        username: 'Si vous ne définissez pas de mot de passe, fournissez un email valide.\n\n Dans le cas contraire, veuillez fournir un mot de passe et un nom d\'utilisateur.',
        password: 'Mot de passe pas assez fort. Veuillez fournir un mot de passe plus fort',
      },
      permissions: 'Vous n\'avez pas les permissions pour {action} les agents. Si vous pensez que c\'est une erreur, essayez à nouveau ou contactez-nous.',
    },
    subscriptions: 'Vous avez {available} utilisateurs disponibles sur {total} pour créer.',
    noSubscriptions: 'Désolé, mais vous avez atteint le maximum de {total} utilisateurs. Contactez-nous pour en obtenir davantage.',
    disconnectionLog: 'Journal de déconnexion',
    sessionId: 'ID de session',
    filters: {
      text: 'Rechercher par noms, email, etc.',
      label: 'Filtres',
    },
    statuses: {
      available: 'Disponible',
      occupied: 'ACD',
      meeting: 'Réunion',
      inCall: 'En appel',
      busy: 'Occupé',
      break: 'Pause',
      bath: 'Toilettes',
      meal: 'Repas',
      gathering: 'Réunion d\'équipe',
      training: 'Formation',
      disconnected: 'Déconnecté',
      releasing: 'Disponible',
      occupying: 'ACD',
    },
    disconnectionReason: {
      transportClose: 'problème de réseau ou fermeture du navigateur',
      clientNamespaceDisconnect: 'déconnexion manuelle',
      pingTimeout: 'latence réseau élevée',
      serverNamespaceDisconnect: 'déconnexion par le serveur',
    },
    metrics: {
      dailyHours: {
        label: 'Heures de connexion quotidiennes',
        hint: 'Heures par jour où l\'agent est connecté dans une vue annuelle',
      },
      occupancyLevel: {
        label: 'Niveau d\'occupation quotidienne (%)',
        hint: 'Pourcentage d\'occupation entre les heures d\'appel et les heures connectées',
      },
      connectionLogs: {
        label: 'Journaux de connexion',
        hint: 'Historique des connexions',
      }
    }
}

};
